import { render, staticRenderFns } from "./bidAmount.vue?vue&type=template&id=0230f222&scoped=true"
import script from "./bidAmount.vue?vue&type=script&lang=js"
export * from "./bidAmount.vue?vue&type=script&lang=js"
import style0 from "./bidAmount.vue?vue&type=style&index=0&id=0230f222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230f222",
  null
  
)

export default component.exports